import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Box } from '@mui/system';
import { Backdrop, CircularProgress } from '@mui/material';
import { useScrollbar } from '@europrocurement/flexy-components';
import { useParcoursFormalite } from './provider';

const ParcoursFormaliteOutlet: React.FunctionComponent = function () {
    const { loading } = useParcoursFormalite();
    const { scrollToTop } = useScrollbar();
    const location = useLocation();

    React.useEffect(() => {
        scrollToTop();
    }, [location.pathname, scrollToTop]);

    return (
        <>
            <Backdrop
                sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
                open={loading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
            <Box sx={{ marginTop: '20px' }}>
                <Outlet />
            </Box>
        </>
    );
};

export default ParcoursFormaliteOutlet;
